import { render, staticRenderFns } from "./FormDiplomaProof.vue?vue&type=template&id=2a4d7f8a&"
import script from "./FormDiplomaProof.vue?vue&type=script&lang=js&"
export * from "./FormDiplomaProof.vue?vue&type=script&lang=js&"
import style0 from "sweetalert2/dist/sweetalert2.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports